import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import HotRanking from "./components/HotRanking";
import CollectionSection from "./components/CollectionSection";
import ReviewSection from "./components/ReviewSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import SubmitSection from "./components/SubmitSection";
import Footer from "./components/Footer";
import FloatingTools from "./components/FloatingTools";

export default function Home() {
  const [keyword, setKeyword] = useState("");
  const [category, setCategory] = useState("");

  const handleSearch = (kw: string) => {
    setKeyword(kw);
    setCategory("");
  };

  const handlePickCategory = (id: string) => {
    setCategory(id);
    setKeyword("");
  };

  return (
    <div className="bg-background-100 text-foreground-800">
      <Navbar />
      <Hero onSearch={handleSearch} />
      <main>
        <CategorySection onPick={handlePickCategory} />
        <HotRanking />
        <CollectionSection category={category} keyword={keyword} />
        <ReviewSection />
        <FaqSection />
        <AboutSection />
        <SubmitSection />
      </main>
      <Footer />
      <FloatingTools />
    </div>
  );
}